import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useCache } from '../utilities/useCache'
import { getUser, userReceived } from '../store/slices/user'
import PicCont from './PicCont'
import SalesValues from './SalesValues'
import SalesPain from './SalesPain'
import SalesMetrics from './SalesMetrics'
import SQMetrics from './SQMetrics'
import SQCurrent from './SQCurrent'
import SQLayout from './SQLayout'
import PreferredPartnership from './PreferredPartnership'
import { apiCallBegan } from '../store/api'
import { refreshURL } from '../store/slices/cache'



const B2BSalesPres = ({id}) => {
    let [step, setStep] = useState(0)
    let{push} = useRouter()
    let dispatch = useDispatch()
    let potential = useCache(`/business/withContacts/${id}`)
    let metrics = useCache(`/business/b2b-metrics`)
    let {user} = useSelector(getUser)

    let values = {
      same_day: ["Same day delivery available", "We accept last minute requests any day of the week so you offer AV services to any client any time"],

customer_service: ["Top rated customer service", "Our blend of technology and talent makes us South Florida’s top rated AV provider"],

fast_quote: ["Fast quoting",  "We provide extremely fast accurate quotes no matter event’s complexity"],

inspiring_planning:  ["Intuitive event planning experience.", "Our intuitive digital platform allows to easily create and visualize  any setup in minutes."],

transparent_pricing:  ["Fair  and transparent Price",  "Our estimates are 40% more cost efficient that average and are fully transparent."],
flawless_execution: ["Flawless event execution", "Our intelligent operating model ensures seamless execution and error avoidance."]


  }
    let pain_points = {
      not_punctual: [
          'Vendor is not punctual',
           'As all our operations are data driven, streamlined and connected, we can ensure full accuracy in our delivery, setup and breakdown times.'],
      slow_quote: [
              'It takes too long to get a quote so I can show a final price to my clients',
               'Our system allows fast planning and booking, because we have every single aspect of the process connected and real time updated we are able to provide an accurate quote and final price in minutes not hours or days'],
      opaque_pricing: [
          'Pricing is difficult to understand',
          'Our pricing is realtime, self explanatory and fully transparent.'],
      untidy_setups: [
          "Setups do not meet our business cleanliness standards",
          'We have procedures that our technicians adhere to in order to leave setups impeccable.'],
      disrupt_operations: [
          'Productions disrupt our regular business operations',
          'Our technicians have the highest customer service rating in South Florida. They are trained to ve meticulous, respectful and stay out of your way so you can operate your business as usual.'],
      unknowledgeable_technicians: [
          'Technicians monitoring the events lack knowledge',
          'Our technicians are certified through our own rigorous theoretical and practical training and quality assurance system.'],
      expensive: [
          'Prices are too expensive for my clients',
          'Our prices are up to 40% cheaper than B2B industry standard, our system automation allows us to saves costs that we later pass on to you.'],
      unreliable_availability: [
          'Vendor not always have availability or the equipment I need',
          'Our team is always ready to service a request 24 / 7. Our extensive inventory guarantees availability even on the busiest days of the year.'],
      rude_technicians: [
          'Technicians customer service does not meet our business standards',
          'We are proud to be the best rated AV provider in South Florida. We guarantee 5-Star customer service to you and your clients.'],
      unadequate_equipment: [
          'The equipment provided is not what I wanted / what I imagined',
          'Our account managers will guide you to select the perfect equipment for every event. Our platform provides pictures, videos and detailed descriptions of every product so you can be confident on your choices.'],


  }

    let steps = [
        <SalesValues key='values' potential={potential} setStep={setStep} values={values} />,
        <SalesPain key='pain' potential={potential} setStep={setStep} pain_points={pain_points} />,
        <SalesMetrics key='values' potential={potential} setStep={setStep} metrics={metrics}  />,
    ]

    let qSteps = [
      <SQLayout key='values' potential={potential} setStep={setStep} />,
      <SQMetrics key='values' potential={potential} setStep={setStep} metrics={metrics}  />,
      <SQCurrent key='pain' potential={potential} setStep={setStep} pain_points={pain_points} values={values} />,
      <PreferredPartnership key='values' potential={potential} setStep={setStep} metrics={metrics} onContinue={() => {
        dispatch(apiCallBegan({url: `/business/edits/${potential?._id}`, method: 'PUT', data: {status: 'engaged'}, onSucessFunc: ()=>  refreshURL(`/business/withContacts/${potential?._id}`)}))
        dispatch(apiCallBegan({ url: `/user/edits/${user?._id}?populated=true`, method: 'PUT', data:{business: potential?._id}, onSuccess: userReceived.type, onExtFunc: () => push('/partner-portal')}))
      }}  />,
  ]



  return <div data-msr-surface='dark' className='salesSlides'>
    <div className='header'>
        <h2> AV Partnership</h2>
        </div>
   {potential?.status !== 'questions' && <div className='subHeader'>
        <h3>Our Vision for {potential?.name}</h3>
        </div>}

  <PicCont priority background picture={potential?.picture} />
  <div className="back"></div>
    {potential?.status === 'questions' ? qSteps[step] :steps[step]}
  </div>
}

export default B2BSalesPres
